import { Component, OnInit } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Store } from "@ngrx/store";
import { AddLinkAction } from "../links.actions";
import { wyswigConfig } from "../../../signatures/signatures.service";
import { MatDialogRef } from "@angular/material/dialog";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../../../shared/error-state-matcher";

@Component({
  selector: "app-link-add",
  templateUrl: "./link-add.component.html",
  styleUrls: ["./link-add.component.scss"],
  standalone: false,
})
export class LinkAddComponent implements OnInit {
  config = wyswigConfig;
  file;
  form: UntypedFormGroup;
  saving = false;
  errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();

  constructor(
    private store: Store,
    private dialogRef: MatDialogRef<LinkAddComponent>,
  ) {}

  ngOnInit(): void {
    this.fillInitialForm();
  }

  fillInitialForm = () => {
    this.form = new UntypedFormGroup({
      name: new UntypedFormControl("", (c) => Validators.required(c)),
      url: new UntypedFormControl("", (c) => Validators.required(c)),
      text: new UntypedFormControl("", (c) => Validators.required(c)),
    });
  };

  onSubmit = () => {
    this.errorStateMatcher.submitAttempted = true;
    if (this.saving || this.form.invalid) {
      return;
    }
    this.saving = true;
    const formValue = this.form.value as {
      name: string;
      url: string;
      text: string;
    };
    this.store.dispatch(new AddLinkAction(formValue));
    this.dialogRef.close(true);
  };

  cancel = () => {
    this.fillInitialForm();
    this.dialogRef.close();
  };
}
